/**
 * NANUK: Back to top button functionality
 * This script handles the visibility and behavior of the back-to-top button
 * It shows the button when the user scrolls past 50% of the page height
 * and provides smooth scrolling back to the top when clicked
 */

document.addEventListener('DOMContentLoaded', () => {
  // NANUK: Get the back-to-top button element
  const backToTopButton = document.querySelector('.back-to-top');
  
  /**
   * NANUK: Update button visibility based on scroll position
   * Shows the button when user has scrolled past 50% of the page
   */
  const updateButtonVisibility = () => {
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollPercentage = (scrollPosition / (documentHeight - windowHeight)) * 100;
    
    backToTopButton.setAttribute('data-visible', scrollPercentage >= 30);
  };
  
  /**
   * NANUK: Smooth scroll to top of the page
   * Uses native smooth scrolling behavior for better performance
   */
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  // NANUK: Add scroll event listener with throttling for better performance
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateButtonVisibility();
        ticking = false;
      });
      ticking = true;
    }
  });
  
  // NANUK: Add click event listener for smooth scrolling
  backToTopButton.addEventListener('click', scrollToTop);
  
  // NANUK: Initial check for button visibility
  updateButtonVisibility();
}); 